import Component from '../Component';
import { loadYTPlayerAPI } from './youtube';

class CustomEmbed extends Component<HTMLElement> {
	static selector = '.custom-embed';

	static children = {
		iframe: 'iframe',
		content: '.embed-content',
	};

	async afterInit() {
		const type =
			this.children?.content.getAttribute('data-embed-type') || '';

		switch (type) {
			case 'youtube':
				await this.bindYoutubeEmbed();
				break;
			default:
		}
	}

	async bindYoutubeEmbed() {
		await loadYTPlayerAPI();

		let width, height;

		if (window.innerWidth < 768) {
				// Adjust width and height for smaller screens
				width = 1000;
				height = 1000;
		} else {
				// Use larger dimensions for screens 768px and above
				width = 1280;
				height = 720;
		}

		const player = new window.YT.Player(
			this.children?.iframe as HTMLElement,
			{
				width,
				height,
				events: {
					onReady: () => {
						this.handleViewportVisibility(undefined, () => {
							player.pauseVideo();
						});
					},
				},
			}
		);
	}

	async handleViewportVisibility(onEntry = () => {}, onLeave = () => {}) {
		const observer = new IntersectionObserver(([{ isIntersecting }]) => {
			if (isIntersecting) {
				onEntry();
			} else {
				onLeave();
			}
		});

		observer.observe(this.children?.iframe as HTMLElement);
	}
}

CustomEmbed.init();
